module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/mo-8d4848888f2e8b82554594097cb5c21b.svg";